export type RateLineStatus = 'current' | 'upcoming' | 'superseded' | 'ended';

interface LineWindow {
  validFrom: string;
  validTo: string | null;
  supersededByLineId: string | null;
}

/** Where a line stands on `today` (an ISO date): in force, still to start, replaced by a newer price, or ended with nothing after it. */
export function rateLineStatus(line: LineWindow, today: string): RateLineStatus {
  if (line.validFrom > today) return 'upcoming';
  if (line.validTo !== null && line.validTo < today) return line.supersededByLineId ? 'superseded' : 'ended';
  return 'current';
}

/** UTC, like the API: a line's boundary day must mean the same in the office as on the server. */
export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

/** A price can be changed while nothing has replaced it and it hasn't ended; a change opens a proposal that takes over on a later date. */
export function canChangePrice(line: LineWindow, today: string): boolean {
  const status = rateLineStatus(line, today);
  return status === 'current' || status === 'upcoming';
}
